<template>
  <div class="radio-group">
    <div>
      <slot />
    </div>
    <div class="radio-group--inline">
      <div
        v-for="(item, index) in options"
        :key="index"
        :class="{ disabled: disabled }"
      >
        <input
          class="form-control"
          :class="{
            disabled: disabled
          }"
          type="radio"
          :name="name"
          :value="item.value"
          v-model="currentValue"
          @change="onChange"
          :disabled="disabled"
          :aria-checked="currentValue === item.value"
          :style="
            size ? `flex: 0 0 ${size}px;width:${size}px;height:${size}px` : ''
          "
        />
        {{ item.label }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  $_veeValidate: {
    // fetch the current value from the innerValue defined in the component data.
    value() {
      return this.currentValue;
    },
    rejectsFalse: true
  },
  name: "UiCheckbox",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null,
      required: true
    },
    size: {
      type: [Number, String],
      validate: val => parseInt(val),
      default: 16
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: null
    };
  },
  methods: {
    onChange() {
      this.$emit("input", Boolean(this.currentValue));
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.currentValue = newVal;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";

.radio-group {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.radio-group--inline {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  @include lg {
    gap: 2rem;
  }

  div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    @include lg {
      gap: 1rem;
    }
  }
}

.disabled {
  color: var(--fe-muted-2);
}

input[type="radio"] {
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  border: 1px var(--fe-base-inverted) solid;
  background: var(--fe-base);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s 0s ease-in-out;
  cursor: pointer;
  border-radius: 100px;

  &.disabled {
    border: 1px var(--fe-muted-2) solid;
    background: var(--fe-muted-4);
    cursor: not-allowed;
    color: var(--fe-muted-4);
  }

  &:after {
    font-size: 12px;
    font-weight: bold;
    content: "✔︎";
    visibility: hidden;

    color: var(--fe-base);
  }

  &[aria-checked] {
    background: 1px var(--fe-base-inverted) solid;
    background: var(--fe-base-inverted);
    color: var(--fe-base);

    &:after {
      visibility: visible;
    }
  }
}
</style>
